/**
 * Created by Bowen on 5/24/2020.
 * Description:
 * Add contact body component
 *
 * ------ maintenance history ------
 */
import { Component, OnInit, Input } from '@angular/core';
import { ContactInformationItemDetail, ContactInformationItemType } from './contact-information-item.model';
import { SlideSheetService } from '../../../../services/slide-sheet.service';
import { SlideSheetActionTypes } from '../../../slide-sheet/slide-sheet.model';

@Component({
    selector: 'tam-contact-information-item',
    templateUrl: './contact-information-item.component.html',
    styleUrls: ['./contact-information-item.component.scss']
})
export class ContactInformationItemComponent implements OnInit {
    @Input() config: ContactInformationItemDetail;
    constructor(
        private _slideSheetService: SlideSheetService,
    ) {
    }

    ngOnInit() {
    }

    onMeatball($event) {
    }

    onItemClick($event, item) {
        if (item.clickable && item.itemType === ContactInformationItemType.Email) {
            window.location.href = 'mailto:' + item.value;
        } else if (item.clickable && item.itemType === ContactInformationItemType.Contact) {
            this._slideSheetService.slideSheetActionSubject$.next({
                type: SlideSheetActionTypes.CONTACT_PANEL,
                payload: item.valueId
            });
        } else if (item.clickable && item.itemType === ContactInformationItemType.Entity && item.value !== '******') {
            // do not need to open slide sheet if the company name is invisible
            this._slideSheetService.slideSheetActionSubject$.next({
                type: SlideSheetActionTypes.ENTITY_PANEL,
                payload: item.valueId
            });
        } else if (item.clickable && item.itemType === ContactInformationItemType.Link) {
            const re = /^((https|http|ftp|rtsp|mms)?:\/\/)/;
            if (re.test(item.value)) {
                window.open(item.value, '_blank');
            } else {
                window.open('http://' + item.value, '_blank');
            }
        }
    }

    trackByFn(index, item) {
        return item.id;
    }
}
